/// <amd-module name="VSSUI/Components/ProgressBar/IndeterminateProgressBar" />
import * as React from "react";

import { ObservableLike } from "VSS/Core/Observable";
import { TimerManagement } from "VSS/Core/TimerManagement";
import { Observer } from "VSSUI/Observer";
import { css } from "VSSUI/Util";
import { IIndeterminateProgressBarProps } from "./ProgressBar.Props";

interface ProgressState {
    progress: number;
}
export class IndeterminateProgressBar extends React.PureComponent<IIndeterminateProgressBarProps, ProgressState> {
    private get transitionDuration() {
        return this.state.progress ? this.transitionDurations : 0;
    }

    private timerManagement: TimerManagement = new TimerManagement();
    private transitionDurations = 350;

    constructor(props: IIndeterminateProgressBarProps) {
        super(props);
        this.state = { progress: 0 };
    }

    public render() {
        return (
            <Observer loading={{ observableValue: this.props.loading, filter: this.updateProgress }}>
                {() => {
                    return (
                        <span className={css(this.props.className, "bolt-progress-bar-container flex-row flex-noshrink flex-grow scroll-hidden")}>
                            <span
                                className={css(
                                    this.props.progressBarClassName,
                                    "bolt-progress-bar-bar",
                                    this.state.progress === Infinity && "complete"
                                )}
                                style={{
                                    transform: `scaleX(${this.asymptoticApproach(this.state.progress)})`
                                }}
                            />
                        </span>
                    );
                }}
            </Observer>
        );
    }

    public componentDidMount() {
        if (this.shouldRun()) {
            this.scheduleUpdate(this.increment, 0, false);
        }
    }

    public componentDidUpdate(prevProps: IIndeterminateProgressBarProps) {
        if (this.shouldRun()) {
            if (this.state.progress == Infinity) {
                if (this.props.loadingAnimationComplete) {
                    this.timerManagement.setTimeout(() => {
                        this.props.loadingAnimationComplete && this.props.loadingAnimationComplete();
                    }, this.transitionDuration);
                }
            } else {
                this.scheduleUpdate(this.increment, this.transitionDuration, false);
            }
        }

        // Reset progress if the loading is undefined, otherwise complete the progress bar if loading is false.
        if (this.props.loading === undefined) {
            this.reset();
        } else if ((prevProps.loading === undefined || ObservableLike.getValue(prevProps.loading)) && !ObservableLike.getValue(this.props.loading)) {
            this.done();
        }
    }

    public componentWillUnmount() {
        this.timerManagement.dispose();
    }

    // Creates a randomize function that takes in a number and spits out a number +/- the percent passed into the function
    private randomize25 = (amount: number) => 0.25 * (Math.random() * amount * 2 + (1 - amount));
    private randomize75 = (amount: number) => 0.75 * (Math.random() * amount * 2 + (1 - amount));

    // We never want to hit 100%
    private asymptoticApproach = (x: number) => 1 - 1 / Math.sqrt(x + 1);

    private scheduleUpdate(updateFn: () => void, delay: number, required: boolean) {
        this.timerManagement.setTimeout(() => {
            updateFn();
        }, delay);
    }

    private done = () => {
        this.state.progress !== Infinity && this.setState({ progress: Infinity });
    };

    private increment = () => {
        this.state.progress !== Infinity && this.setState({ progress: this.state.progress + this.randomize25(1) });
    };

    private reset = () => {
        this.state.progress !== 0 && this.setState({ progress: 0 });
    };

    private shouldRun = () => {
        // If we have a value start the progress.
        return this.props.loading != undefined;
    };

    private updateProgress = (restart: boolean) => {
        if (restart) {
            this.reset();
        } else {
            this.done();
        }
    };
}
